import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pi0033',
    ecrans: [
        '00-2',
        '01-2'
    ]
});
